<template>
  <div class="app-fcst">
    <div
      class="airport-tab-content"
    >
      <div
        class="fcst-discussion"
        v-text="data"
      />
    </div>
  </div>
</template>
<script>
import * as LayerUpdateTimeService from '../../services/layerUpdateTime/layerUpdateTime.service';

export default {
  name: 'ForecastComponent',
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        LayerUpdateTimeService.setCurrentScreenRenderTime();
      },
    },
  },
};
</script>
<style scoped>
.fcst-discussion {
  white-space: pre-wrap;
  font-family: ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono",
    "Roboto Mono", "Oxygen Mono", "Ubuntu Monospace", "Source Code Pro",
    "Fira Mono", "Droid Sans Mono", "Courier New", monospace !important;
}
</style>
